const ACL = {
  install (Vue, options) {
    options = { ...options }
    const store = options.store

    /**
     * Resolve a single permission string against the user's permissions.
     * Supports AND via '&' and OR via '|':
     *   'a&b'  → user must have BOTH a and b
     *   'a|b'  → user must have EITHER a or b
     *   'a'    → user must have a
     */
    const resolveSingle = function (perm, permissions) {
      if (perm.includes('|')) {
        return perm.split('|').some(p => permissions.includes(p.trim()))
      }
      if (perm.includes('&')) {
        return perm.split('&').every(p => permissions.includes(p.trim()))
      }
      return permissions.includes(perm.trim())
    }

    /**
     * resolveCan: returns true if the user satisfies the permission requirement.
     * - Array: user needs AT LEAST ONE of the listed permissions (OR)
     * - String: evaluated by resolveSingle (supports '|' and '&')
     */
    const resolveCan = function (perms) {
      const permissions = store.getters['Auth/getPermissions']
      const isAdmin = store.getters['Auth/isAdmin']
      if (isAdmin) return true
      if (Array.isArray(perms)) {
        return perms.some(p => resolveSingle(p, permissions))
      }
      return resolveSingle(perms, permissions)
    }

    /**
     * resolveCannot: inverse of resolveCan (no admin bypass — cannot means cannot).
     */
    const resolveCannot = function (perms) {
      const permissions = store.getters['Auth/getPermissions']
      if (Array.isArray(perms)) {
        return perms.every(p => !resolveSingle(p, permissions))
      }
      return !resolveSingle(perms, permissions)
    }

    Vue.directive('can', {
      inserted (el, binding) {
        if (!resolveCan(binding.value)) {
          if (binding.modifiers.disable) {
            if (window.$(el).hasClass('el-button')) {
              window.$(el).addClass('is-disabled').attr('disabled', true).css({ pointerEvents: 'none' })
            } else if (window.$(el).hasClass('el-select-dropdown__item')) {
              window.$(el).addClass('is-disabled').css({ pointerEvents: 'none' })
            } else {
              window.$(el).attr('disabled', true).addClass('is-disabled').css({ pointerEvents: 'none' })
            }
          } else if (binding.modifiers.event) {
            if (window.$(el).hasClass('el-dropdown')) {
              window.$(el).find('button:first').addClass('is-disabled').attr('disabled', true).css({ pointerEvents: 'none' })
            }
          } else {
            window.$(el).remove()
          }
        }
      }
    })

    Vue.directive('cannot', {
      inserted (el, binding) {
        if (!resolveCannot(binding.value)) {
          if (binding.modifiers.disable) {
            if (window.$(el).hasClass('el-button')) {
              window.$(el).addClass('is-disabled').attr('disabled', true)
            } else {
              window.$(el).attr('disabled', true)
            }
          } else {
            window.$(el).remove()
          }
        }
      }
    })

    Vue.prototype.$can = function (permissions) {
      return resolveCan(permissions)
    }

    Vue.prototype.$cannot = function (permissions) {
      return resolveCannot(permissions)
    }
  }
}

export default ACL
